import { Resolver } from "@craftjs/core";
import PageButton from "./editor-components/page-specific/custom/Button";
import PageButtonContainer from "./editor-components/page-specific/custom/ButtonContainer";
import PageContent from "./editor-components/page-specific/custom/Content";
import PageContentContainer from "./editor-components/page-specific/custom/Content/components/Container";
import TagContainer from "./editor-components/page-specific/custom/Content/components/TagContainer";
import Grid from "./editor-components/page-specific/custom/Grid";
import PageHeader from "./editor-components/page-specific/custom/Header";
import PageIntro from "./editor-components/page-specific/custom/Header/components/Intro";
import PageTitle from "./editor-components/page-specific/custom/Header/components/Title";
import PageHeading from "./editor-components/page-specific/custom/Heading";
import Page from "./editor-components/page-specific/custom/Page";
import PageParagraph from "./editor-components/page-specific/custom/Paragraph";
import Spotlight from "./editor-components/page-specific/custom/Spotlight";
import SpotlightButton from "./editor-components/page-specific/custom/Spotlight/components/Button";
import SpotlightText from "./editor-components/page-specific/custom/Spotlight/components/Text";
import DownloadsContent from "./editor-components/page-specific/downloads/Content";
import DownloadsHeading from "./editor-components/page-specific/downloads/Content/components/Heading";
import DownloadsHeader from "./editor-components/page-specific/downloads/Header";
import DownloadsIntro from "./editor-components/page-specific/downloads/Header/components/Intro";
import DownloadsTitle from "./editor-components/page-specific/downloads/Header/components/Title";
import DownloadsSpotlight from "./editor-components/page-specific/downloads/Spotlight";
import HomeContent from "./editor-components/page-specific/home/Content";
import HomeButton from "./editor-components/page-specific/home/Content/components/HomeButton";
import HomeButtonContainer from "./editor-components/page-specific/home/Content/components/HomeButtonContainer";
import HomeHeading from "./editor-components/page-specific/home/Content/components/HomeHeading";
import HomeMedia from "./editor-components/page-specific/home/Content/components/HomeMedia";
import HomeParagraph from "./editor-components/page-specific/home/Content/components/HomeParagraph";
import HomeTextContainer from "./editor-components/page-specific/home/Content/components/HomeTextContainer";
import HomeHeader from "./editor-components/page-specific/home/Header";
import HomeTitle from "./editor-components/page-specific/home/Header/components/Title";
import HomeVideo from "./editor-components/page-specific/home/Header/components/Video";
import { Step1Content, Step2Content, Step3Content } from "./editor-components/page-specific/steps/Content";
import StepButton from "./editor-components/page-specific/steps/Content/components/Button";
import StepButtonContainer from "./editor-components/page-specific/steps/Content/components/ButtonContainer";
import ContentContainer from "./editor-components/page-specific/steps/Content/components/ContentContainer";
import FilterContainer from "./editor-components/page-specific/steps/Content/components/FilterContainer";
import StepHeading from "./editor-components/page-specific/steps/Content/components/Heading";
import StepParagraph from "./editor-components/page-specific/steps/Content/components/Paragraph";
import StepTextContainer from "./editor-components/page-specific/steps/Content/components/TextContainer";
import StepHeader from "./editor-components/page-specific/steps/Header";
import StepIntro from "./editor-components/page-specific/steps/Header/components/Intro";
import StepTitle from "./editor-components/page-specific/steps/Header/components/Title";
import StepSpotlight from "./editor-components/page-specific/steps/Spotlight";
import Div from "./editor-components/shared/Div";
import Media from "./editor-components/shared/Media";
import TableBlock from "./editor-components/shared/TableBlock/TableBlock";

export const resolver: Resolver = {
    // Global/Shared
    Page,
    Spotlight,
    SpotlightText,
    SpotlightButton,
    Media,
    TableBlock,
    Div,
    Grid,
    ContentContainer,
    FilterContainer,

    // Home
    HomeHeader,
    HomeTitle,
    HomeVideo,
    HomeContent,
    HomeHeading,
    HomeTextContainer,
    HomeParagraph,
    HomeMedia,
    HomeButtonContainer,
    HomeButton,

    // Steps
    StepHeader,
    StepTitle,
    StepIntro,
    Step1Content,
    Step2Content,
    Step3Content,
    StepHeading,
    StepTextContainer,
    StepParagraph,
    StepSpotlight,
    StepButton,
    StepButtonContainer,

    // Downloads
    DownloadsHeader,
    DownloadsTitle,
    DownloadsIntro,
    DownloadsContent,
    DownloadsHeading,
    DownloadsSpotlight,

    // Content page
    PageHeader,
    PageTitle,
    PageIntro,
    PageContent,
    PageHeading,
    PageParagraph,
    PageContentContainer,
    TagContainer,
    PageButton,
    PageButtonContainer,
} as const;
